<div class="login">
    
    <div class="container text-center mt-5 mb-5">
      <img src="../../../../assets/images/realdesk-logo.png">
    </div>

    <div class="container content-login">
      <div class="row">
        
        <div class="col-md-6">
          <img src="../../../../assets/images/ilustration_login.svg" class="img-fluid">
        </div>

        <div class="col-md-6 card"  *ngIf="finished == false">

                  <!-- Barra de progresso -->
        <div class="progress-bar">
          Etapa {{currentStep}} de 5
          <div class="progress" [style.width.%]="progressPercentage"></div>
        </div>

                  <!-- Título e descrição -->
        <h3 class="step-title text-center">{{ stepTitles[currentStep - 1] }}</h3>
        <p class="step-description text-center mb-4">{{ stepDescriptions[currentStep - 1] }}</p>


          <form class="form" [formGroup]="loginForm">


            <div *ngIf="currentStep === 1">
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input type="text" class="form-control" placeholder="Digite seu e-mail" formControlName="emailComercial">
                <div *ngIf="loginForm.get('emailComercial')?.touched && loginForm.get('emailComercial')?.invalid" class="text-danger mt-1">
                  Email é obrigatório e deve ser válido
                </div>
              </div>
              <button class="btn btn-primary" (click)="nextStep()" [disabled]="!loginForm.get('emailComercial')?.valid">Próximo</button>
            </div>
            
            <div *ngIf="currentStep === 2">
              <div class="mb-3">
                <label class="form-label">Nome</label>
                <input type="text" class="form-control" placeholder="Digite seu nome" formControlName="nomeUsuario">
                <div *ngIf="loginForm.get('nomeUsuario')?.touched && loginForm.get('nomeUsuario')?.invalid" class="text-danger mt-1">
                  Nome é obrigatório
                </div>
              </div>
              
              <div class="d-flex justify-content-between align-items-center mt-4">
                <button class="btn btn-secondary me-2" (click)="previousStep()">Voltar</button>
                <button *ngIf="currentStep < 5" class="btn btn-primary ms-auto" (click)="nextStep()" >Próximo</button>
              </div>
            </div>
            

            
            <div *ngIf="currentStep === 3">

              <label class="form-label">Nome da empresa</label>
              <input type="text" class="form-control" placeholder="Nome da sua empresa" formControlName="nomeEstabelecimento">
              <div *ngIf="loginForm.get('nomeEstabelecimento')?.touched && loginForm.get('nomeEstabelecimento')?.invalid" class="text-danger mt-1">
                Nome da sua empresa é obrigatório
              </div>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <button class="btn btn-secondary me-2" (click)="previousStep()">Voltar</button>
                <button *ngIf="currentStep < 5" class="btn btn-primary ms-auto" (click)="nextStep()" >Próximo</button>
              </div>
            </div>

            <div *ngIf="currentStep === 4">
              <div class="mb-3">
                <label class="form-label">Telefone de contato (whatsapp)</label>
                <div class="row">
                  <div class="col-md-4">
                      <input class="form-control" type="text" required="" placeholder="DDD" formControlName="ddd">
                  </div>
                  <div class="col-md-8">
                      <input class="form-control" type="text" required="" placeholder="Digite seu telefone" formControlName="telefone">
                  </div>
              </div>
                <div *ngIf="loginForm.get('telefone')?.touched && loginForm.get('telefone')?.invalid" class="text-danger mt-1">
                  Telefone de contato (whatsapp) é obrigatório e somente números
                </div>
              </div>

              <div class="d-flex justify-content-between align-items-center mt-4">
                <button class="btn btn-secondary me-2" (click)="previousStep()">Voltar</button>
                <button *ngIf="currentStep < 5" class="btn btn-primary ms-auto" (click)="nextStep()" >Próximo</button>
              </div>
            </div>
            
            <div *ngIf="currentStep === 5">
              <div class="mb-3">
                <label class="form-label">Senha</label>
                <input type="password" class="form-control" placeholder="Digite sua senha" formControlName="senha">
                <div *ngIf="loginForm.get('senha')?.touched && loginForm.get('senha')?.invalid" class="text-danger mt-1">
                  Senha é obrigatória
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-4">
                <button class="btn btn-secondary me-2" (click)="previousStep()">Voltar</button>
                <button class="btn btn-success" (click)="create()">Finalizar</button>
              </div>
            </div>

          </form>

          <!-- Texto de consentimento -->
        <div class="consent-text mt-4 text-center">
          <p>
            Ao enviar meus dados pessoais, autorizo a RealDesk a coletar, processar e armazenar minhas informações de acordo com o <a href="#" target="_blank">Aviso de Privacidade</a>, conforme descrito em <a href="#" target="_blank">Aviso de Privacidade da RealDesk</a>.
          </p>
        </div>
        </div>
        

        <div class="col-md-6 card" *ngIf="finished == true">

          <h3 class="step-title text-center">Ótimo! Agora verifique o seu e-mail</h3>
          <br>
          <p class="step-description text-center mb-4">Depois da verificação, você será encaminhado para o seu novo endereço realdesk.app e poderá começar sua avaliação gratuita</p>
  
          <div class="button-container">
            <a href="https://gmail.com" target="_blank">
              <img src="https://web-assets.zendesk.com/images/p-register/gmail.svg" alt="Gmail">Abrir Gmail
            </a>
            <a href="https://outlook.live.com" target="_blank">
              <img src="https://web-assets.zendesk.com/images/p-register/outlook.svg" alt="Outlook">Abrir Outlook
            </a>
            <a href="https://mail.yahoo.com" target="_blank">
              <img src="https://web-assets.zendesk.com/images/p-register/yahoo.svg" alt="Yahoo">Abrir Yahoo!
            </a>
            <a href="https://icloud.com/mail" target="_blank">
              <img src="https://web-assets.zendesk.com/images/p-register/icloud.png" alt="iCloud">Abrir Mail da Apple
            </a>
          </div>

        </div>

      </div>
    </div>

      <!-- Links fixos no rodapé -->
  <footer class="footer mt-5 text-center">
    <p>&copy; RealDesk 2025</p>
    <a href="#" target="_blank">Aviso de Privacidade</a> | 
    <a href="#" target="_blank">Contrato Principal de Serviços</a>
  </footer>
</div>